import store from '../../../store';
import setGlobalState from '../../../redux/setGlobalState';

export function mergeCurrentFormValues(fields: Record<string, unknown> | null | undefined): void {
    if(!fields || !Object.keys(fields).length) {
        return;
    }
    const prev = store.getState().aiAgent?.currentFormValues || {};
    setGlobalState('aiAgent.currentFormValues', {...prev, ...fields});
}
